var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.851563 5.124L11.5056 10.665C11.6124 10.7206 11.7311 10.7496 11.8516 10.7496C11.972 10.7496 12.0907 10.7206 12.1976 10.665L22.8516 5.125V14.75C22.8516 15.5801 22.534 16.3788 21.9639 16.9822C21.3938 17.5856 20.6144 17.948 19.7856 17.995L19.6016 18H4.10156C3.27142 18.0001 2.47273 17.6824 1.86933 17.1123C1.26593 16.5422 0.903561 15.7628 0.856563 14.934L0.851563 14.75V5.124ZM4.10156 6.97519e-09H19.6016C20.4317 -5.43467e-05 21.2304 0.317554 21.8338 0.887671C22.4372 1.45779 22.7996 2.23719 22.8466 3.066L22.8516 3.25V3.434L11.8516 9.154L0.851563 3.434V3.25C0.851508 2.41986 1.16912 1.62117 1.73923 1.01777C2.30935 0.414367 3.08876 0.0519987 3.91756 0.00500012L4.10156 6.97519e-09H19.6016H4.10156Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.9ecfea6bc0ef3c8580ad1dfdfab8c5d3.svg";
export { ForwardRef as ReactComponent };